import React, { Component } from 'react'

export default class Header extends Component {
    render() {
        return (

            <div className='container-fluid m-0 p-0'>
                <div style={{
                    width: "100%",
                    height: "49px",
                    paddingLeft: "5%",
                    paddingRight: "5%",
                    display: "flex",
                    backgroundColor: "rgb(236 246 248)",
                    fontWeight: "400",

                    alignItems: "center",
                    boxSizing: "border-box",
                    color: "#5c636c",
                    fontSize: "12px",
                    /*  boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",*/
                    borderBottom: "1px solid rgb(222 240 244)"
                }}>
                    <div className='row' style={{alignItems:"center", width:"100%"}}>
                        <div className='col-auto pe-1'>
                            <i className="bi bi-circle-fill" style={{
                                color: "#4abbc1",
                                fontSize: "10px"
                            }}></i>
                        </div>
                        <div className='col-auto ps-1'>
                            Holideus - Trusted Travel platforms in 50+ countries
                        </div>
                        <div className='col text-end'>
                            <button className='btn btn-primary btn-sm me-1'>Russian</button>
                            <button className='btn btn-sm me-1'>English</button>
                            <button className='btn btn-sm'>Turkish</button>
                        </div>

                    </div>

                </div>

                <div style={{
                    width: "100%",
                    height: "72px",
                    paddingLeft: "5%",
                    paddingRight: "5%",
                    display: "flex",
                    backgroundColor: "white",
                    fontWeight: "400",

                    alignItems: "center",
                    boxSizing: "border-box",
                    color: "#5c636c",
                    fontSize: "12px",
                    /*  boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",*/
                    borderBottom: "1px solid rgb(222 240 244)"
                }}>

                    <div className='row' style={{alignItems:"center", width:"100%"}}>
                        <div className='col-auto'>
                            <img src='/Assets/img/logo.jpg' alt="Holideus Logo" style={{
                                height: "50px",
                                width: "150px",
                                objectFit: "contain"
                            }} />
                        </div>
                        <div className='col text-end pe-5'>
                            <ul className="nav justify-content-end menu">
                                <li className="nav-item">
                                    <a className="nav-link" href="#">Why Choose</a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" href="#">Solutions</a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" href="#">Comparison</a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" href="#">FAQ</a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link">|</a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" href="#">Login</a>
                                </li>
                                <li className="nav-item">
                                    <button className='btn btn-primary ms-3'>Get Started</button>
                                </li>

                            </ul>
                        </div>
                    </div>

                </div>
                



            </div>

        )
    }
}
